module.exports = __webpack_public_path__ + "static/media/4.ddfd8ba5.gif";